import { InjectionToken } from '@angular/core';

/* tslint:disable:variable-name */
export const FormControlToken: any = new InjectionToken('FormControlToken');
/* tslint:enable:variable-name */
